function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3293 -1338) translate(3060 164) translate(205 144) translate(0 970) translate(16 16) translate(0 32) translate(12 12)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#F44336",
  rx: 20
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7FAFE",
  d: "M25.508 9.524H13.559c-.314 0-.568.253-.568.564V28.97h13.084V10.088c0-.31-.253-.564-.567-.564zm-6.87 17.041c0 .193-.157.35-.351.35h-2.465c-.194 0-.352-.157-.352-.35v-2.448c0-.194.158-.351.352-.351h2.465c.194 0 .35.157.35.35v2.449zm0-4.793c0 .193-.157.35-.351.35h-2.465c-.194 0-.352-.157-.352-.35v-2.448c0-.194.158-.351.352-.351h2.465c.194 0 .35.157.35.35v2.45zm.799-5.413l-1.389.725c-.153.08-.332-.049-.303-.219l.266-1.536c.011-.067-.011-.136-.06-.184l-1.123-1.088c-.124-.12-.055-.329.116-.354l1.552-.224c.067-.01.127-.052.157-.114l.693-1.397c.077-.154.299-.154.374 0l.695 1.397c.03.062.09.104.157.114l1.552.224c.17.025.24.235.116.354l-1.123 1.088c-.05.048-.072.117-.06.184l.264 1.536c.03.17-.149.299-.303.22l-1.387-.726c-.06-.032-.134-.032-.194 0zm4.16 10.206c0 .193-.158.35-.352.35h-2.464c-.194 0-.353-.157-.353-.35v-2.448c0-.194.159-.351.353-.351h2.464c.194 0 .351.157.351.35v2.449zm0-4.793c0 .193-.158.35-.352.35h-2.464c-.194 0-.353-.157-.353-.35v-2.448c0-.194.159-.351.353-.351h2.464c.194 0 .351.157.351.35v2.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCC",
  d: "M29.68 28.97H26.1V18.288h3.025c.306 0 .555.247.555.552v10.13zM9.386 28.97h3.581V18.288H9.941c-.306 0-.555.247-.555.552v10.13z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EC4813",
  d: "M30.694 28.97H8.372c-.416 0-.753.337-.753.753s.337.753.753.753h22.322c.416 0 .753-.337.753-.753s-.337-.753-.753-.753z"
})))))))));

var SvgIconServHotel = function SvgIconServHotel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconServHotel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-serv-hotel.e7a5011f.svg";
export { ForwardRef as ReactComponent };